import Mime from 'mime/lite';
import { ExportValue } from '../ExportDimension';
import { ExportFormat, ExportOutput } from '../ExportFormat';

const meta = () => '<meta http-equiv="content-type" content="text/html; charset=utf-8">';
const pad = (by: number) => new Array(by).fill(' ').join('');
const elmt = (tag: string) => (indent: number, ...inner: string[]) =>
    `${pad(indent)}<${tag}>\r\n${inner.join('\r\n')}\n${pad(indent)}</${tag}>`;
const val = (indent: number, inner: string) => `${pad(indent)}${inner?.toString()?.trim() ?? ''}`;
const table = elmt('table');
const tbody = elmt('tbody');
const tr = elmt('tr');
const td = elmt('td');

export class HtmlTableExportFormat implements ExportFormat {

    public readonly id = 'htmlTable';
    public readonly label = 'HTML Table';
    public readonly desc = 'Copy and paste into Confluence, Word, Notion or other wiki/processor applications.';

    public apply(data: ExportValue[][]): ExportOutput[] {

        const doc = [
            meta(),
            table(0,
                tbody(4,
                    ...data.map(row => tr(8,
                        ...row.map(cell => td(12,
                            val(16, cell.value)
                        ))
                    ))
                )
            ),
        ];

        const raw = doc.join('\r\n');

        return [
            ExportOutput(Mime.getType('html'), raw),
            ExportOutput(Mime.getType('text'), raw)
        ];
    }

}
